import { contentTabFramePrefix } from "../../utils/constants";
import { useRootSelector } from "../useAppSelector";
export const useFrameSessionResolver = () => {
    const { activeTabKey, tabs } = useRootSelector();
    const resolve = (iframeName) => {
        if (iframeName === "Bands") {
            return tabs[activeTabKey].frameSession;
        }
        if (tabs.hasOwnProperty(iframeName)) {
            return tabs[iframeName].frameSession;
        }
        if (iframeName.startsWith(contentTabFramePrefix)) {
            const testName = iframeName.substring(contentTabFramePrefix.length);
            if (tabs.hasOwnProperty(testName)) {
                return tabs[testName].frameSession;
            }
        }
        let session = null;
        Object.entries(tabs).forEach(([key, entry]) => {
            if (window?.frames[key] &&
                window.frames[key].FrameSessionInnerResolver) {
                if (window.frames[key].FrameSessionInnerResolver(iframeName)) {
                    session = entry.frameSession;
                    return;
                }
            }
        });
        return session;
    };
    return { resolve };
};
